import React from "react";

/**
 * ErrorBoundary — вловлює помилки рендеру в усьому дереві під ним.
 * Без нього будь-який exception під час рендеру дає порожній чорний/сірий екран
 * (залежно від теми Telegram) і ніякої діагностики. З ним користувач побачить
 * повідомлення + stack trace, який можна надіслати скріншотом.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null, info: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const { error, info } = this.state;
    const stack = error?.stack || "";
    const componentStack = info?.componentStack || "";
    const message = String(error?.message || error || "");

    return (
      <div
        style={{
          minHeight: "100dvh",
          background: "#0f172a",
          color: "#fff",
          padding: "1.5rem",
          fontFamily:
            "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h2 style={{ margin: 0, fontSize: "1.25rem", color: "#fca5a5" }}>
          Щось пішло не так
        </h2>
        <p style={{ margin: 0, color: "#cbd5e1", fontSize: "0.9rem" }}>
          Будь ласка, зроби скріншот цієї сторінки й надішли нам.
        </p>

        <pre
          style={{
            margin: 0,
            padding: "0.75rem",
            background: "#1e293b",
            borderRadius: "0.5rem",
            overflow: "auto",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            color: "#fca5a5",
            fontSize: "0.8rem",
            flex: "1",
            minHeight: "6rem",
          }}
        >
{message}
{stack ? "\n\n" + stack : ""}
{componentStack ? "\n\n--- component stack ---\n" + componentStack : ""}
        </pre>

        <button
          onClick={this.handleReload}
          style={{
            alignSelf: "flex-start",
            padding: "0.5rem 1.25rem",
            borderRadius: "0.5rem",
            border: "none",
            background: "#10b981",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Перезавантажити
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;